module.exports = __webpack_public_path__ + "4bc43fc12a30958e95fdd6395e934770.svg";